// extracted by mini-css-extract-plugin
export default {"breadcrumbsContainer":"breadcrumbs-module--breadcrumbsContainer--9dc31"};